import styled from "@emotion/styled"
import { css } from '@emotion/react'
import facepaint from "facepaint"

const breakpoints = [860]
const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`))

const wrapOpen = ({ isOpen }) => {
  if (isOpen) {
    return css({
      transform: "translateX(0) translateZ(0px)",
    })
  }
}

const wrapMQ = css(mq({
  display: ["flex", "none"],
}))

export const Wrap = styled.div`
  display: flex;
  background: var(--color-white);
  flex-direction: column;
  gap: 40px;
  padding: 104px 40px 40px;
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  will-change: transform;
  transform: translateX(-100%) translateZ(0px);
  transition: transform var(--transition);
  ${wrapOpen}
  ${wrapMQ}
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
`

export const Caption = styled.div`
  font: var(--text-540);
  color: var(--color-grayscale-400);
  margin-bottom: 4px;
`

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 0;
`
